import React, { useEffect, useState, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { FacebookShareButton, FacebookIcon } from "react-share";
import "./style.scss";

const ResultModal = (props) => {
  const [quote, setQuote] = useState("");
  const latestProps = useRef(props);
  const history = useHistory();
  useEffect(() => {
    latestProps.current = props;
  });
  useEffect(() => {
    let quote = `Are you contemplating an investment? Inviting your crush for a dinner? Going for a poker night? Let Lucky7 calculate you lucky odds of the hour! \n This last hour ${
      latestProps.current.sum >= latestProps.current.average
        ? `I was LUCKY and beat the average ${latestProps.current.average} with ${latestProps.current.sum}!!!`
        : "I WASN'T lucky. I'll try again in an hour!"
    }`;
    setQuote(quote);
  }, []);
  const handleClickShowRank = () => {
    history.push(
      props.isTest ? "/signin" : "/chart",
      props.isTest ? "guest" : "rank"
    );
  };
  return (
    <>
      <img
        alt="logo"
        src={require("./../../assets/images/logo.svg")}
        className="modal-logo"
      ></img>
      <div className="modal-header">
        <div style={{ fontSize: "22px" }}>Your score is:</div>
        <div
          className="modal-header-score"
          style={
            props.sum < props.average
              ? { color: "white" }
              : { color: "#ffcc00" }
          }
        >
          {props.sum}
          <div
            style={{
              color: "white",
              fontSize: "27px",
              fontWeight: "400",
            }}
          >
            + {parseFloat(props.decimal) * 1000} <br />
            <div style={{ color: "white", fontSize: "13px" }}>milliseconds</div>
          </div>
        </div>
        {props.sum < props.average ? (
          <>
            <div className="modal-header-comment">NOT SO LUCKY!</div>
            <div className="modal-header-comment-low">
              Your score is below this hours average({props.average}).
            </div>
          </>
        ) : (
          <>
            <div className="modal-header-comment" style={{ color: "#ffcc00" }}>
              YOU ARE LUCKY!
            </div>
            <div className="modal-header-text">
              Your score is above this hours average({props.average}).
            </div>
          </>
        )}
      </div>
      <div className="modal-body">
        <div className="modal-body-group">
          <button
            className="modal-body-group-button"
            onClick={handleClickShowRank}
          >
            SHOW MY RANK!
          </button>
          <FacebookShareButton
            url={"https://www.lucky7.games/guest"}
            quote={quote}
            className="modal-body-group-fb"
          >
            <div className="modal-body-group-fb-text">SHARE ON</div>
            <FacebookIcon
              size={40}
              round={true}
              className="modal-body-group-fb-icon"
            />
          </FacebookShareButton>
        </div>
        {/* <Link to="/challenge" style={{ textDecoration: "none", zIndex: "1" }}>
        <button className="modal-body-challenge">
          <div>CHALLENGE FRIENDS</div>
          <FacebookIcon
            size={55}
            round={true}
            className="modal-body-challenge-icon"
          />
        </button>
      </Link> */}
        {/* <div className="modal-body-comment">
        Friends will have to beat your next score!
      </div> */}
      </div>
      <div className="modal-footer">
        <button className="modal-footer-back" onClick={props.handleCloseModal}>
          BACK TO RESULTS
        </button>
        <Link
          to={{
            pathname: props.isTest ? "/signin" : "/profile",
            state: "result",
          }}
        >
          <button
            className="modal-footer-profile"
            onClick={props.handleCloseModal}
          >
            MY PROFILE
          </button>
        </Link>
      </div>
    </>
  );
};

export default ResultModal;
